import React from 'react';
import { MenuItem, Intent } from "@blueprintjs/core";
import { MultiSelect } from "@blueprintjs/select";

class FilterMultiSelect extends React.Component {
    state = {
        items: []
    }
    shouldComponentUpdate(nextProps, nextState) {
        return this.props.items !== nextProps.items || nextState.items !== this.state.items;
    }
    deselectItem = (index) => {
        this.setState({ items: this.state.items.filter((_, i) => i !== index) });
    }
    selectItem = (item) => {
        this.setState({ items: [...this.state.items, item[this.props.id]] });
    }
    onItemSelect = (item) => {
        const itemIndex = this.state.items.indexOf(item[this.props.id]);
        if (itemIndex === -1) {
            this.selectItem(item);
        } else {
            this.deselectItem(itemIndex);
        }
    }
    componentWillUpdate(prevProps, prevState) {
        this.props.onItemChange && this.props.onItemChange(prevState.items);
    }
    handleTagRemove = (tag, index) => {
        this.deselectItem(index);
    }
    filterItem = (text = '', item) => {
        text =  text.toLowerCase();
        const textDisplay = typeof item[this.props.text] !== 'string' ? item[this.props.text].toString() : item[this.props.text];


        return item[this.props.text] && ((textDisplay && textDisplay.toLowerCase().includes(text)) || (item[this.props.label] && item[this.props.label].toLowerCase().includes(text)))
    }
    countryRenderer = (item, {index, handleClick}) => {
        const isSelected = this.state.items.indexOf(item[this.props.id]) > -1;
        return (
            <MenuItem
                icon={isSelected ? 'tick' : 'blank'}
                key={index}
                label={this.props.label && item[this.props.label] ? item[this.props.label] : null}
                onClick={handleClick}
                text={item[this.props.text]}
                shouldDismissPopover={false}
            />
        );
    }
    render() {
        return (
            <MultiSelect
                itemRenderer={this.countryRenderer}
                items={this.props.items}
                tagRenderer={this.props.tagRenderer ? item => this.props.tagRenderer(item) : item => item}
                itemPredicate={(text, item) => this.filterItem(text, item)}
                popoverProps={{ minimal: true, ...this.props.popoverProps }}
                tagInputProps={{ tagProps: {intent: Intent.NONE, minimal: true}, onRemove: this.handleTagRemove, placeholder: this.props.placeholder }}
                noResults={<MenuItem disabled={true} text={this.props.items.length === 0 ? this.props.noResultText || 'No results.' : 'No results.'} />}
                selectedItems={this.state.items}
                onItemSelect={this.onItemSelect} />
        )
    }
}

export default FilterMultiSelect;



// WEBPACK FOOTER //
// ./src/components/widgets/FilterMultiSelect.jsx